import Spinner from '../spinner/Spinner';
import Footer from '../footer/Footer';
import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import '../../assets/styles/TopHeader.css'; // Make sure this path is correct
import bannerImageUrl from '../../assets/images/terms.jpg';
import Arise4uBlackLogo from '../../assets/images/logo/arise logo 95.svg';

const TermsAndCondition = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isMediaOpen, setIsMediaOpen] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const headerRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  useEffect(() => {
    const handleScroll = () => {
      if (headerRef.current) {
        if (window.scrollY > 50) {
          headerRef.current.classList.add('sticky');
        } else {
          headerRef.current.classList.remove('sticky');
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      {/* The main container fragment */}
      <>
        <section
          ref={headerRef}
          className="privacy-header-banner"
          style={{ backgroundImage: `url(${bannerImageUrl})` }}
        >
          <div className="privacy-header-content-wrapper">
           

            <section className="privacy-hero-section">
              <h1 className="privacy-hero-title font-bold">Terms & Conditions</h1>
            </section>
          </div>
        </section>


        <section className='legalpage-container mb-5'>
          <div className='custom-padding-three'>
            <div className='legalpage-contents mt-3 pt-3 mt-md-5'>
              <div>
                <p className='font-medium fs-5'>
                  This section sets forth the legally binding terms and conditions (“Terms”) that govern your participation in the ARISE FOR YOU™ Program organized by HCLTech in collaboration with Pearson and MSH and supported by Thought Pencil. The initiative is designed to identify, inspire, and incubate the next generation of student entrepreneurs across India.
                </p>
                <p className='font-medium fs-5'>
                  In alignment with the vision of MeitY Startup Hub to foster inclusive innovation and deep-tech entrepreneurship, HCLTech and Pearson envisions ARISE as a catalytic platform that can channel young talent into India’s startup ecosystem. The program also directly supports national objectives such as Digital India, Startup India, and Skill India, by translating entrepreneurial mindset into actionable ventures, policy insight, and regional innovation growth.
                </p>
                <p className='font-medium fs-5'>
                  Please read these Terms and Conditions carefully before using and/or registering on the site because by accessing or registering or using the site or any mobile versions of it or by linking to it, you signify that you have read, understood and agreed to be bound by these Terms and Conditions for or participating in the ARISE FOR YOU™ Program.
                </p>
              </div>
              <div className='mt-5'>
                <>
                  <h2 className="mb-3 font-bold txt-blue">1.1 DEFINITIONS</h2>
                  <ul>
                    <li className='font-medium fs-5'>“Organizers” refers to HCLTech , Pearson and Thought Pencil Communications.</li>
                    <li className='font-medium fs-5'>“Participant” refers to students, faculty, and institutions registering for the Program.</li>
                    <li className='font-medium fs-5'>“ESB Certification” refers to the Entrepreneurship and Small Business certification by Pearson Certiport.</li>
                    <li className='font-medium fs-5'>“Program Website” refers to the official ARISE FOR YOU™ website managed by the Organizers.</li>
                  </ul>
                </>
                <>
                  <h2 className="mt-4 mb-3 font-bold txt-blue">1.2 ELIGIBILITY</h2>
                  <ul>
                    <li className="font-medium fs-5">Participants must meet the eligibility criteria outlined in Section 3: Eligibility Criteria.</li>
                    <li className="font-medium fs-5">Institutions must be legally recognized by relevant Indian Statutory Bodies (for example: UGC, AICTE, etc.) during the term of the program.</li>
                  </ul>
                </>
                <>
                  <h2 className="mt-4 mb-3 font-bold txt-blue">1.3 REGISTRATION & ENROLLMENT</h2>
                  <ul>
                    <li className="font-medium fs-5">Registration must be completed through the official Program Website: www.ariseforyou.com</li>
                    <li className="font-medium fs-5">Enrollment fees of ₹2,990/- per student are payable upfront via the designated payment gateway.</li>
                    <li className="font-medium fs-5">Registrations are confirmed only upon successful payment receipt.</li>
                    <li className="font-medium fs-5">Multiple team registrations from the same institution are allowed.</li>
                    <li className="font-medium fs-5">Participants cannot be part of multiple teams.</li>
                  </ul>
                </>
                <>
                  <h2 className="mt-4 mb-3 font-bold txt-blue">1.4 PARTICIPATION RULES</h2>
                  <ul>
                    <li className="font-medium fs-5">All participants must complete the ESB Certification as a pre-requisite for the business challenge.</li>
                    <li className="font-medium fs-5">Business ideas submitted must be original and non-infringing on any intellectual property rights.</li>
                    <li className="font-medium fs-5">Institutions must ensure a minimum of 5 teams participate from their end. Each team must comprise a minimum of 5 and shall not exceed 10 members in a team.</li>
                    <li className="font-medium fs-5">Teams must follow the prescribed format, deadlines, and submission guidelines.</li>
                  </ul>
                </>
                <>
                  <h2 className="mt-4 mb-3 font-bold txt-blue">1.5 INTELLECTUAL PROPERTY</h2>
                  <ul>
                    <li className="font-medium fs-5">The ownership of the submitted ideas or solutions will remain with the respective participants.</li>
                    <li className="font-medium fs-5">Organizers reserve the right to use submitted business ideas, presentations, videos, and images for marketing, promotional and to evaluate for the Finale Event.</li>
                    <li className="font-medium fs-5">The ideas of teams that do not progress to the Finale Event will be returned to the respective teams within 30 days of the Finale Event.</li>
                    <li className="font-medium fs-5">Participants must ensure all content is original and does not infringe on third-party IP rights (including images, music, code, etc.).</li>
                    <li className="font-medium fs-5">Any plagiarism or copyright violation will result in participation disqualification and potential legal action.</li>
                  </ul>
                </>
                <>
                  <h2 className="mt-4 mb-3 font-bold txt-blue">1.6 Communication</h2>
                  <ul>
                    <li className="font-medium fs-5">All official communication, doubts, and announcements will happen via the designated communication channels to the participants registered contact details.</li>
                    <li className="font-medium fs-5">Participants are responsible for checking updates regularly on these channels.</li>
                  </ul>
                </>
                <>
                  <h2 className="mt-4 mb-3 font-bold txt-blue">1.7 FEES & REFUND POLICY</h2>
                  <ul>
                    <li className="font-medium fs-5">All fees are non-refundable except under valid conditions as outlined in the Section 4:Refund Policy.</li>
                    <li className="font-medium fs-5">No partial refunds or fee adjustments are permitted.</li>
                    <li className="font-medium fs-5">Organizers are not responsible for any bank or transaction charges incurred during payment.</li>
                  </ul>
                </>
                <>
                  <h2 className="mt-4 mb-3 font-bold txt-blue">1.8 DISQUALIFICATION</h2>
                  <p className="font-bold fs-5 mt-3">Fair Play & Ethics</p>
                  <ul>
                    <li className="font-medium fs-5">All participants must act honestly, respectfully, and ethically throughout the program.</li>
                    <li className="font-medium fs-5">Cheating, impersonation, harassment, or any discriminatory behavior will lead to immediate disqualification.</li>
                    <li className="font-medium fs-5">Collaboration outside of teams, flag/answer sharing, or using unauthorized tools or shortcuts is prohibited.</li>
                    <li className="font-medium fs-5">Any plagiarism or copyright violation or third-party IP infringement claims will result in participation disqualification and potential legal action.</li>
                  </ul>
                  <p className="font-bold fs-5 mt-3">Code of Conduct</p>
                  <ul>
                    <li className="font-medium fs-5">Participants are expected to uphold a positive, inclusive, and collaborative environment.</li>
                    <li className="font-medium fs-5">Any form of bullying, harassment, or disrespect towards peers or organizers is strictly prohibited.</li>
                    <li className="font-medium fs-5">Failing to adhere to the above will lead to disqualification of the individual participant and/or entire team and may invite legal action. Participants may also be disqualified under the following conditions:</li>
                  </ul>
                  <ul>
                    <li className="font-medium fs-5">Providing false information during registration.</li>
                    <li className="font-medium fs-5">Engaging in plagiarism or fraudulent practices.</li>
                    <li className="font-medium fs-5">Violating / challenging rules or Non-Compliance with instructions given by the Organizers across the program duration.</li>
                    <li className="font-medium fs-5">In case any registration fee payment made via credit card, in such case any denial on part of releasing the payment to organizers, leads to disqualification of such participant or team.</li>
                  </ul>
                </>
                <>
                  <h2 className="mt-4 mb-3 font-bold txt-blue">1.9 WINNERS & PRIZES</h2>
                  <ul>
                    <li className="font-medium fs-5">Winners will be decided by an appointed jury, and all decisions will be final and binding. Any challenge to the jury’s decision shall not be entertained.</li>
                    <li className="font-medium fs-5">Prizes are non-transferable and subject to applicable taxes as per Indian law.</li>
                    <li className="font-medium fs-5">Organizers reserve the right to substitute prizes with similar value items without any notice if required.</li>
                  </ul>
                </>
                <>
                  <h2 className="mt-4 mb-3 font-bold txt-blue">1.10 PRIVACY & DATA USAGE</h2>
                  <ul>
                    <li className="font-medium fs-5">Participant data will be collected, stored, and processed in compliance with applicable Indian data privacy laws.</li>
                    <li className="font-medium fs-5">Details regarding privacy practices are outlined in the ARISE FOR YOU™ Privacy Policy.</li>
                  </ul>
                </>
                <>
                  <h2 className="mt-4 mb-3 font-bold txt-blue">1.11 LIABILITY LIMITATION</h2>
                  <ul>
                    <li className="font-medium fs-5">Organizers shall not be liable for any indirect, incidental, or consequential damages arising from participation in the Program.</li>
                    <li className="font-medium fs-5">Organizers’ total liability is limited to the amount paid by the participant towards enrollment.</li>
                  </ul>
                </>
                <>
                  <h2 className="mt-4 mb-3 font-bold txt-blue">1.12 FORCE MAJEURE</h2>
                  <ul>
                    <li className="font-medium fs-5">The Organizers shall not be held responsible for any delay or failure in performance resulting from circumstances beyond their reasonable control, including but not limited to natural disasters, government restrictions, pandemics, or disruptions in digital services.</li>
                  </ul>
                </>
                <>
                  <h2 className="mt-4 mb-3 font-bold txt-blue">1.13 GOVERNING LAW & JURISDICTION</h2>
                  <ul>
                    <li className="font-medium fs-5">These Terms shall be governed by and construed in accordance with the laws of India.</li>
                    <li className="font-medium fs-5">Any disputes arising from the Program shall be subject to the exclusive jurisdiction of courts in New Delhi, India.</li>
                  </ul>
                </>
                <>
                  <h2 className="mt-4 mb-3 font-bold txt-blue">1.14 AMENDMENTS/ ORGANIZATION’S RIGHTS</h2>
                  <ul>
                    <li className="font-medium fs-5">Organizers reserve the right to amend, modify, or update these Terms & Conditions at any time without prior notice. Participants are advised to review the Terms periodically.</li>
                    <li className="font-medium fs-5">Organizers reserve the right to disqualify any participant/team for misconduct, Non-Compliance, or at their discretion.</li>
                    <li className="font-medium fs-5">Organizers reserve the right to select alternatives in case of participant/team disqualification.</li>
                  </ul>
                </>
              </div>
            </div>
          </div>
        </section>

        {/* You had this commented out, but I'll leave it here */}
        {/* <Footer /> */}
      </>

      {/* Spinner for loading state */}
      {isLoading && <Spinner />}
    </>
  );
};

export default TermsAndCondition;